import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import CustomModal from '../Modal';
import CustomTooltip from '../Tooltip.js';

import { useTemplateConfig } from '../../context/TemplateConfigContext';

const images = {
    settingsWhite: require('shared_img/icons/settings-white.svg'),
};

const DataComponentTableColumns = ({
        settingKey = '',
        data = {},
        onApply: onApplyProp,
        t,
        ...props
    }) => {
    const { assets } = useTemplateConfig();
    const [state, setState] = useState({
        key: settingKey,
        data: data,
        isVisibleModal: false,
    });

    const staticNames = (t && t.reportPage) || {};
    const staticActions = (t && t.actions) || {};

    useEffect(() => {
        if (data !== state.data) {
            setState(prevState => ({
                ...prevState,
                data: data
            }));
        }
    }, [data]);

    const onToggle = useCallback((event) => {
        const index = event.target.closest('.checkbox').getAttribute('data-index');
        const checked = event.target.checked;
        let newData = Array.isArray(state.data) ? [...state.data] : Object.values(state.data);

        newData[index].visible = checked;

        setState(prevState => ({
            ...prevState,
            data: Array.isArray(data) ? newData : Object.fromEntries(newData.map((item, i) => [item.keyTitle || i, item]))
        }));
    }, [state.data, data]);

    const onApply = useCallback(() => {
        if (!state.key) return;
        if (onApply) {
            onApplyProp(state.key, state.data);
        }
        onToggleModal();
    }, [state.key, state.data, onApplyProp]);

    const onToggleModal = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            isVisibleModal: !prevState.isVisibleModal
        }));
    }, []);

    return (
        <React.Fragment>
            <CustomTooltip id={`metricsPopupTooltip`} tooltip={staticNames.metricsTitle}>
                <button id="metricsPopup" className="btn" onClick={onToggleModal}>
                    <img src={assets.icons.settings} alt=""/>
                </button>
            </CustomTooltip>

            <CustomModal
                className={'settingsMenu'}
                title={staticNames.metricsTitle}
                confirmName={staticActions.apply}
                visible={state.isVisibleModal}
                onClose={onToggleModal}
                onConfirm={onApply}
            >
                <div className="row">
                    <div className="col-xs-12">
                        <div className="dbox-body">
                            <div className="dbox-labels">
                                {(Array.isArray(state.data) ? state.data : Object.values(state.data || {})).map((item, i) => {
                                    if (item.disabled) return null;
                                    if (!item.title) {
                                        item.title = item.keyTitle;
                                    }

                                    return (
                                        <div className="checkbox" key={i} data-index={i}>
                                            <input
                                                id={`column-${i}`}
                                                type="checkbox"
                                                checked={item.visible}
                                                onChange={onToggle}
                                            />
                                            <label htmlFor={`column-${i}`}>{Parser(item.title)}</label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </CustomModal>
        </React.Fragment>
    );
};

DataComponentTableColumns.propTypes = {
    settingKey: PropTypes.string,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onApply: PropTypes.func,
    t: PropTypes.object
};

export default withTranslation(DataComponentTableColumns);
